import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';

import { insurancePoliciesFetch, InsurancePoliciesFetchPayload } from './action';
import { PolicyControlForm } from './policy-control-form';
import { PolicyList } from './policy-list';

const InsurancePolicyListPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const payload: InsurancePoliciesFetchPayload = Object.fromEntries(searchParams);
    dispatch(insurancePoliciesFetch(payload));
  }, [searchParams]);

  return (
    <section>
      <h5 className="mb-4">{t('common:policy')}</h5>
      <PolicyControlForm />
      <Card className="mb-4">
        <Card.Body>
          <PolicyList />
        </Card.Body>
      </Card>
    </section>
  );
};

export { InsurancePolicyListPage };
